export enum PaymentType {
  Quotation,
  BoxOffice,
  Bill,
  ChangePackage,
  Amount,
  Tokenize,
  RecurringPayment,
}

export enum PaymentAttribution {
  BuyPrinciplePackage = 'dswebbp',
  PayAccount = 'dswebpa',
  ChangePackage = 'dswebpa', // TODO: Add specific JID for this
  InternetChangePackage = 'dswebpa', // TODO: Add specific JID for this
  InternetPayReconnect = 'dswebpr', // TODO: Add specific JID for this
  PayReconnect = 'dswebpr',
  SetCreditCard = 'dswebsc',
  XtraViewLink = 'dswebax',
  SubscriptionWaiverLink = 'dswebfsw',
  FuneralPolicyLink = 'dswebffp',
  DebtWaiver = 'dswebfdw',
  DeviceInsurance = 'dswebfdi',
  ReconnectAddOns = 'dswebraad',
  ReconnectAddOnsAndPrincipal = 'dswebpradd',
  LinkAddOns = 'dswebpa', // TODO: Add specific JID for this
  SwitchToContract = 'dswebpa', // TODO: Add specific JID for this
}